import { useEffect, useRef } from 'react';
import { isEmptyObj } from '@app/utils/utils';

const useGoogleTagManager = ({ flowConfig }) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    if (isEmptyObj(flowConfig)) return;

    const tracker = flowConfig.getTracker('GoogleTagManager');
    if (!tracker) return;

    const id = tracker.getParamValue('id');
    const url = tracker.getParamValue('url');
    const getSrc = (i, dl) => url ?
      `${url}?aw=${i.replace(/^GTM-/, '')}${dl}` :
      `//www.googletagmanager.com/gtm.js?id=${i}${dl}` ;

    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(), event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = getSrc(i, dl);
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', id);

    hasInitialized.current = true;
  }, [flowConfig]);
};

export default useGoogleTagManager;